module.exports = __webpack_public_path__ + "img/GH-kyujin-top-006.fdaada12.webp";